import React, { useEffect, useRef } from 'react';
import crossIcon from '../../assets/svg/cross.svg'
// import { XMarkIcon } from "@heroicons/react/24/outline";

interface ModalProps {
    isOpen: boolean;
    onClose: (e: any) => void;
    children: React.ReactNode;
    size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'x-lg';
    className?: any,
    parentClassName?: any
}

export default function Modal({ isOpen, onClose, children, size = 'md', className, parentClassName }: ModalProps) {
    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            const toastContainer = document.querySelector('.Toastify__toast-container');
            if (modalRef.current && !modalRef.current.contains(event.target as Node) &&
                (!toastContainer || !toastContainer.contains(event.target as Node))) {
                // onClose(event);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    let sizeClass = '';
    switch (size) {
        case 'xxs':
            sizeClass = 'w-[36%]';
            break;
        case 'xs':
            sizeClass = 'w-[40%]';
            break;
        case 'sm':
            sizeClass = 'w-[45%]';
            break;
        case 'md':
            sizeClass = 'w-[50%]';
            break;
        case 'lg':
            sizeClass = 'w-[75%]';
            break;
        case 'x-lg':
            sizeClass = 'w-[90%]';
            break;
        default:
            sizeClass = 'w-[20%]';
            break;
    }

    function extractTopValue(str: { match: (arg0: RegExp) => any[]; }) {
        // const str = "top-[12px] left-[1145px]";

        const topMatch = str?.match(/top-\[(\d+px)\]/);
        const leftMatch = str?.match(/left-\[(\d+px)\]/);

        const topValue = topMatch ? topMatch[1] : "";
        const leftValue = leftMatch ? leftMatch[1] : "";

        return {
            top: topValue,
            left: leftValue
        }
    }


    return (
        <div className={`fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-50 ${parentClassName}`}>
            <div ref={modalRef} className={`my-12 relative bg-white rounded-basicRadius shadow-lg py-2 px-4 ${sizeClass}  modal-content ${className}`}
                style={{ ...extractTopValue(className) }}
            >
                <button
                    onClick={onClose}
                    className="btnCloseModal absolute z-10 top-3 right-3 text-gray-600 hover:text-gray-800 cross_icon"
                >
                    {/* <XMarkIcon className="size-6 text-darkGreyCol" /> */}
                    {/* {"x"} */}
                    <img src={crossIcon} alt="" />
                </button>
                {children}
            </div>
        </div>
    );
};
